import React, { useContext } from 'react';
import { Container } from 'reactstrap';
import { BirdseedContainer, BirdseedBox } from './styles';
import HomeContext from '../../contexts/HomeContext';
import { createSafeHtml } from '../../utils/sanitizeHtml';

const Birdseed = () => {
  const { birdSeedText } = useContext(HomeContext);
  return !birdSeedText ? null : (
    <BirdseedContainer className="pt-3">
      <Container>
        <BirdseedBox
          className="text-white p-0"
          dangerouslySetInnerHTML={createSafeHtml(birdSeedText)}
        />
      </Container>
    </BirdseedContainer>
  );
};

export default Birdseed;
